<div class="input-group">
  <label
    class="input-group__label"
    [class.input-group__label--with-tips]="hasTips"
    [attr.for]="id"
    [class.sr-only]="isHiddenLabel"
  >
    {{ formattedLabel }}

    <ng-content select="[custom-label]"></ng-content>

    <span *ngIf="hasTips" class="input-group__tips">{{ tips }}</span>
  </label>

  <ng-content></ng-content>

  <div
    *ngIf="formattedErrors?.length"
    [attr.id]="errorsId"
    class="input-group__error-container"
  >
    <p class="error" *ngFor="let error of formattedErrors">
      <vtmn-play-icon
        [name]="icon"
        class="error__icon"
        [class.success__icon]="codeIsValid"
      ></vtmn-play-icon>
      <span [class.success__text]="codeIsValid">{{ error }}</span>
    </p>
  </div>
</div>
